const API_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:5000'
  : 'https://api.instation.app';

const apiConfig = {
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
};

export { API_URL, apiConfig }; 
